"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var CtaButton_1 = require("../common/Btn/CtaButton");
var TargetSymptomsModule = function () {
    return ((0, preact_1.h)("div", { className: "target-symptoms-module" },
        (0, preact_1.h)("div", { className: "target-symptoms-module__mobile-hero-container hide-on-desktop" },
            (0, preact_1.h)("img", { className: "target-symptoms-module__hero-image", src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-mobile.jpg?v=1726096704" }),
            (0, preact_1.h)("img", { className: "target-symptoms-module__bubble", src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-bubble-mobile.png?v=1727295414" })),
        (0, preact_1.h)("div", { className: "target-symptoms-module__hero-container hide-on-mobile" },
            (0, preact_1.h)("div", { className: "target-symptoms-module__hero-text-container" },
                (0, preact_1.h)("p", { className: "target-symptoms-module__header" },
                    "Target Symptoms",
                    (0, preact_1.h)("br", null),
                    "at the Source"),
                (0, preact_1.h)("p", { className: "target-symptoms-module__subheader" },
                    "We offer a wide range of innovative,",
                    (0, preact_1.h)("br", null),
                    "results-driven products designed to",
                    (0, preact_1.h)("br", null),
                    "help women feel better."),
                (0, preact_1.h)("div", { className: "target-symptoms-module__cta" },
                    (0, preact_1.h)(CtaButton_1.default, { backgroundColor: {
                            to: 'Left',
                            startColor: 'gogo-orange',
                            endColor: 'gogo-pale-orange',
                        }, hoverColor: "white", text: "SHOP ALL", scrollTo: "/collections/shop-all" })))),
        (0, preact_1.h)("div", { className: "target-symptoms-module__container" },
            (0, preact_1.h)("p", { className: "target-symptoms-module__header hide-on-desktop" },
                "Target Symptoms",
                (0, preact_1.h)("br", null),
                "at the Source"),
            (0, preact_1.h)("p", { className: "target-symptoms-module__subheader hide-on-desktop" },
                "We offer a wide range of innovative,",
                (0, preact_1.h)("br", null),
                "science-backed products with results",
                (0, preact_1.h)("br", null),
                "you can feel."),
            (0, preact_1.h)("div", { className: "target-symptoms-module__facts" },
                (0, preact_1.h)("div", { className: "target-symptoms-module__fact" },
                    (0, preact_1.h)("p", { className: "target-symptoms-module__fact-main target-symptoms-module__fact-main--1" }, "#1"),
                    (0, preact_1.h)("p", { className: "target-symptoms-module__fact-text" },
                        (0, preact_1.h)("b", null, "Creators of the first"),
                        " PMS &",
                        (0, preact_1.h)("br", null),
                        "Menopause Gummy Vitamins")),
                (0, preact_1.h)("div", { className: "target-symptoms-module__fact" },
                    (0, preact_1.h)("p", { className: "target-symptoms-module__fact-main target-symptoms-module__fact-main--2" }, "100%"),
                    (0, preact_1.h)("p", { className: "target-symptoms-module__fact-text" },
                        "Every production run",
                        (0, preact_1.h)("br", null),
                        "undergoes strict 3rd-party",
                        (0, preact_1.h)("br", null),
                        "testing for ",
                        (0, preact_1.h)("b", null, "purity & potency"))),
                (0, preact_1.h)("div", { className: "target-symptoms-module__fact" },
                    (0, preact_1.h)("p", { className: "target-symptoms-module__fact-main target-symptoms-module__fact-main--3" },
                        "2,500+",
                        (0, preact_1.h)("br", null),
                        (0, preact_1.h)("span", null, "studies")),
                    (0, preact_1.h)("p", { className: "target-symptoms-module__fact-text" },
                        "Our ingredients are evaluated",
                        (0, preact_1.h)("br", null),
                        (0, preact_1.h)("b", null, "in over 2,500 studies")))),
            (0, preact_1.h)("div", { className: "target-symptoms-module__cta hide-on-desktop" },
                (0, preact_1.h)(CtaButton_1.default, { backgroundColor: {
                        to: 'Left',
                        startColor: 'gogo-orange',
                        endColor: 'gogo-pale-orange',
                    }, hoverColor: "gogo-orange", text: "SHOP ALL", scrollTo: "/collections/shop-all" })))));
};
exports.default = TargetSymptomsModule;
